import { modals } from '@mantine/modals';
import type { AdditionalResourcesSelection } from 'app/Private/Clients/Detail/UnhandledInvoicesTab/ChooseAdditionalInvoices';
import { ChooseAdditionalInvoices } from 'app/Private/Clients/Detail/UnhandledInvoicesTab/ChooseAdditionalInvoices';
import type { ActionType, UnhandledInvoice } from 'modules/AtRisk/api/use-load-unhandled-client';

// Opens the invoice selection modal restricted to unhandled invoices only
// (no additional invoices, credit notes or payments). Shared by every action
// that is not a third party action, which still shows the full resource list.
// Kept out of the actions barrel (index.ts) so it is only ever imported directly.
type OpenUnhandledInvoiceSelectionModalArgs = {
  title: string;
  selectedInvoiceIds: Array<string>;
  invoices: Array<UnhandledInvoice>;
  actionType: ActionType | 'pause';
  onNext: (selection: AdditionalResourcesSelection) => void;
  areAllInvoicesEligible?: boolean;
  // True when confirming the selection performs the action straight away, so the
  // submit button reads "Confirm" rather than "Next".
  isFinalStep?: boolean;
};

export function openUnhandledInvoiceSelectionModal({
  title,
  selectedInvoiceIds,
  invoices,
  actionType,
  onNext,
  areAllInvoicesEligible,
  isFinalStep,
}: OpenUnhandledInvoiceSelectionModalArgs) {
  modals.open({
    size: 'lg',
    title,
    children: (
      <ChooseAdditionalInvoices
        selectedInvoiceIds={selectedInvoiceIds}
        unhandledInvoices={invoices}
        actionType={actionType}
        showAdditionalResources={false}
        areAllInvoicesEligible={areAllInvoicesEligible}
        isFinalStep={isFinalStep}
        onNext={onNext}
      />
    ),
  });
}
